import { jsx as _jsx } from "react/jsx-runtime";
import { ToasterPortal } from '../_base/ToasterPortal.js';
import { ToastItemStatus } from '../../types.js';
import { exists } from '@nu-art/ts-common';
import { ToasterItem } from '../../ToasterItem/ToasterItem.js';
import './ToasterPortal_TopDown.scss';
import { createRef } from 'react';
export class ToasterPortal_TopDown extends ToasterPortal {
    toasterItemLineClamp = 1;
    ref = createRef();
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.height = nextProps.height;
        state.topOffset = nextProps.topOffset ?? 0;
        return state;
    }
    componentDidUpdate() {
        this.processItems();
    }
    // ######################### Logic #########################
    getCurrentlyVisibleElement() {
        if (!this.ref.current?.children)
            return;
        const children = Array.from(this.ref.current.children);
        return children[0];
    }
    processItems() {
        //No items to process, or first item is currently on screen or transitioning out
        const nextVisibleItem = this.state.items[0];
        if (!nextVisibleItem || nextVisibleItem.status !== ToastItemStatus.Loaded)
            return;
        //Set line capping based on portal height
        if (nextVisibleItem.model.body) {
            const element = this.getCurrentlyVisibleElement();
            //Ramp up element linecap on the body until it overflows
            if (element) {
                const maxHeight = this.state.height - this.state.topOffset;
                let previousCalculatedHeight;
                let lineClamp = 0;
                while (!previousCalculatedHeight || previousCalculatedHeight < maxHeight) {
                    lineClamp++;
                    element.style.setProperty('--line-clamp', `${lineClamp}`);
                    const currentCalculatedHeight = element.getBoundingClientRect().height;
                    //If upping the line clamp did not change the height then we can stop checking here
                    if (previousCalculatedHeight && currentCalculatedHeight === previousCalculatedHeight)
                        break;
                    previousCalculatedHeight = currentCalculatedHeight;
                }
                this.toasterItemLineClamp = lineClamp - 1;
                element.style.setProperty('--line-clamp', `${lineClamp - 1}`);
            }
        }
        this.state.items[0].status = ToastItemStatus.Visible;
        this.reportConsumeModel(this.state.items[0].model.id);
        this.forceUpdate();
    }
    // ######################### Render #########################
    render() {
        const item = this.state.items[0];
        return _jsx("div", { ref: this.ref, className: 'toasting-portal__top-down', style: { height: `${this.state.height}px` }, children: exists(item) && _jsx(ToasterItem, { model: item.model, status: item.status, style: {
                    top: `${this.state.topOffset}px`,
                    ['--line-clamp']: `${this.toasterItemLineClamp}`
                } }, item.model.id) });
    }
}
//# sourceMappingURL=ToasterPortal_TopDown.js.map